define('presentation/welcome/common/onboardingSectionValidationDisplay',[], function() {
    return function() {
        const self = this;

        let _showValidation = null;
        let _disposables = [];

        const _captureSections = [];

        self.init = (showValidation) => {
            _showValidation = showValidation;
        };

        // A section switched on after the last submit has not been through a
        // validation run of its own, so it holds its errors back until the user
        // submits again with the section on screen. Its fields still validate
        // either way - this gates the display only, so the Next button stays
        // gated on them the whole time. Switching a section on returns it to
        // that state, however many times it happens.
        self.createSectionDisplay = (shouldDisplaySection) => {
            const wasDisplayedAtLastSubmit = ko.observable(false);

            _disposables.push(shouldDisplaySection.subscribe((isDisplayed) => {
                if (isDisplayed) {
                    wasDisplayedAtLastSubmit(false);
                }
            }));
            _captureSections.push(() => {
                wasDisplayedAtLastSubmit(shouldDisplaySection() ? true : false);
            });

            return ko.pureComputed(() => _showValidation() === true && wasDisplayedAtLastSubmit() === true);
        };

        // Call alongside showValidation(true) when a step is submitted: the
        // sections on screen at that moment are the ones allowed to show errors.
        self.captureDisplayedSections = () => {
            _captureSections.forEach((captureSection) => captureSection());
        };

        self.detached = () => {
            _disposables.forEach((subscription) => subscription.dispose());
            _disposables = [];
        };
    };
});

